import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "custom-form-select"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#custom-form-select" }),
  /*#__PURE__*/_createTextVNode(" Custom Form Select ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".form-select-solid"),
  /*#__PURE__*/_createTextVNode(" class with "),
  /*#__PURE__*/_createVNode("code", null, ".form-select"),
  /*#__PURE__*/_createTextVNode(" to set solid background style for a form select: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10\"><label for=\"exampleFormControlInput1\" class=\"form-label\">Select option</label><select class=\"form-select form-select-solid\" aria-label=\"Select example\" id=\"exampleFormControlInput1\"><option>Open this select menu</option><option value=\"1\">One</option><option value=\"2\">Two</option><option value=\"3\">Three</option></select></div><div class=\"mb-10\"><label for=\"exampleFormControlTextarea1\" class=\"form-label\">Select options</label><select class=\"form-select form-select-solid\" aria-label=\"Select example\" multiple=\"multiple\" id=\"exampleFormControlTextarea1\"><option>Open this select menu</option><option value=\"1\">One</option><option value=\"2\">Two</option><option value=\"3\">Three</option></select></div>", 2)
const _hoisted_8 = { class: "py-0" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="mb-10">
              <label for="exampleFormControlInput1" class="form-label"
                >Select option</label
              >
              <select
                class="form-select form-select-solid"
                aria-label="Select example"
              >
                <option selected>Open this select menu</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>

            <div class="mb-10">
              <label for="exampleFormControlTextarea1" class="form-label"
                >ESelect options</label
              >
              <select
                class="form-select form-select-solid"
                aria-label="Select example"
                multiple="multiple"
              >
                <option selected>Open this select menu</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>
            `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}